export var fromUtf8 = function fromUtf8(input) {
  return new TextEncoder().encode(input);
};